import { mapGetters } from "vuex";
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators' 

export default {
  mixins: [validationMixin],
  validations: {
    select:{
      region: {required},
      specialization: {required},
      },
    },
  data: () => ({
    isLoading:false,
    select:{
      region: null,
      specialization: null,
    },
    page: 1,
    total: null,
    customer1: '/static/img/customer1.png',
    spec:[],
    region:[],
    advocats:[]
  }),

  mounted () {
    if(this.$route.query.id_spec){
      this.select.specialization = parseInt(this.$route.query.id_spec);
    }
    if(this.$route.query.id_reg ){
      this.select.region = [parseInt(this.$route.query.id_reg)];
    }
    if(this.$route.query.id_spec && this.$route.query.id_reg){
      this.getAdocate();
    }
    if(this.$route.query.id){
      this.select.specialization = this.$route.query.id;
    
    }
    if(!this.$route.query.id && !this.$route.query.id_reg && !this.$route.query.id_spec){
      this.select = {
        region: null,
        specialization: null,
      }
    }
    this.loadDate();
  },
  computed: {
    ...mapGetters(['getApi']),
    regionErrors () {
      const errors = []
      if (!this.$v.select.region.$dirty) return errors
      !this.$v.select.region.required && errors.push('Обязательное поле')
      return errors
    },
    specializationErrors () {
      const errors = []
      if (!this.$v.select.specialization.$dirty) return errors
      !this.$v.select.specialization.required && errors.push('Обязательное поле')
      return errors
    },
  },
  methods: {
    setAll(event){
      if(event){
        this.select.region = [];
        this.region.forEach(item => {
          this.select.region.push(item.id);
        });
      }else{
        this.select.region = [];
      };
    },
    loadDate(){
      this.isLoading = true;
      this.$axios.get('auth/registration/atribute').then(res => {
        if(res.data.cod == 200){
          this.region = res.data.result.region;
          this.spec = res.data.result.specialization;
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    toProfile(item){
      this.$router.push({ path: 'profile', query: { id: item.uid }})
    },
    toCreate(item){
      this.$root.$emit('modal.create', { id: item.uid });
    },
    loadAdvocate(){
      this.page = 1;
      this.getAdocate();
    },
    getAdocate(){
      this.isLoading = true;
      console.log(this.select);
      this.$axios.post('adv/list?page=' + this.page, this.select).then(res => {
        if(res.data.cod == 200){
          this.advocats = res.data.result.data;
          this.current_page = res.data.result.current_page;
          this.total = res.data.result.last_page;
        }
      }).finally(() => {
        this.isLoading = false;
        this.$nextTick(() => {
          $('#app-content').scrollTop(0);
          $('#app-content_mobile').scrollTop(0);
        }); 
      });
    },
  },
  send(){
    if(this.getApi){
      this.select.region = this.getApi.region;
      this.select.specialization = this.getApi.specialization;
    }
    this.$v.select.$touch();
    if(this.$v.select.$invalid){
      return;
    } 
  },
  watch :{
    page(to, from) {
      this.getAdocate();
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/Search/search.js